import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { formatDate } from "../../../utils/dates";

import Toast from "../../../components/common/toast/Toast";
import ProjectDetail from "./detail/components/ProjectDetail/ProjectDetail";
import ProjectSOWView from "./statementOfWork/components/ProjectSOW/ProjectSOWView";
import ProjectSOWEdit from "./statementOfWork/components/ProjectSOW/ProjectSOWEdit";
import Messages from "../../common/messages/Messages";
import CompleteProjectModal from "../../common/completeProjectModal/CompleteProjectModal";

import { Mixpanel } from "../../../actions/mixpanel.actions";
import * as projectActions from "../../../actions/project.actions";
import * as commonActions from "./../../../actions/common.actions";
import * as dropdownsActions from "../../../actions/dropdowns.actions";
import * as citiesActions from "../../../actions/cities.actions";

const subHeader = (projectId, activeItem) => {
  return {
    items: [
      {
        caption: "Detail",
        url: `/member/project/${projectId}/detail`
      },
      {
        caption: "Statement of Work",
        url: `/member/project/${projectId}/sow`
      },
      {
        caption: "Messages",
        url: `/member/project/${projectId}/messages`
      }
    ],
    activeItem
  };
};

const pitchItHeaderBar = (match, pitchMatch, rejectMatch) => ({
  color: "blue",
  title: "It’s a match!",
  text:
    "You need to pitch the project before you can message the Company. " +
    "If you’re interested and available, click “Pitch It”. Otherwise, click “No Thanks” to decline.",
  buttons: [
    {
      text: "No Thanks",
      onClick: () => rejectMatch(match)
    },
    {
      color: "blue",
      text: "Pitch It",
      onClick: () => pitchMatch(match)
    }
  ]
});

const awaitingPitchApprovalHeaderBar = (
  created_at,
  projectId,
  showViewMessageButton
) => ({
  color: "grey",
  title: "Pitch Awaiting Approval",
  text: (
    <span>
      You pitched this Project on{" "}
      <strong>{formatDate(created_at, "MMMM Do, YYYY")}. </strong>
      If selected by the Company you can draft a formal SOW. Until then, chat
      with the hiring manager in Messages.
    </span>
  ),
  buttons: showViewMessageButton
    ? [
        {
          text: "View Messages",
          type: "link",
          to: `/member/project/${projectId}/messages`
        }
      ]
    : null
});

const pitchAcceptedHeaderBar = () => ({
  color: "green",
  title: "Pitch Accepted",
  text:
    "Woot woot! your pitch has been accepted and the Company has requested a formal statement of work. " +
    "Please fill out the SOW to move ahead with the hiring process."
});

const awaitingSowApprovalHeaderBar = created_at => ({
  color: "grey",
  title: "Statement of Work Awaiting Approval",
  text: (
    <span>
      You submitted your Statement of Work on{" "}
      <strong>{formatDate(created_at, "MMMM Do, YYYY")}. </strong>
      You can still make edits to this until the Company accepts your SOW. Keep
      an eye on your email for alerts from the Company.
    </span>
  )
});

const editsRequestedHeaderBar = () => ({
  color: "grey",
  title: "Edits Requested",
  text: `You have edits requested to be made on this SOW.
   Please incorporate those changes and resubmit the SOW`
});

const sowApprovedHeaderBar = (completeProject, projectId) => ({
  color: "blue",
  title: "SOW Approved",
  text:
    "Great job! Your project is underway. After you’ve completed the project, " +
    "click the button on the right to kick off the invoicing and review process.",
  buttons: [
    {
      color: "blue",
      text: "Complete Project",
      type: "modalTrigger",
      modalProps: {
        completeProject,
        projectId
      },
      modal: CompleteProjectModal
    }
  ]
});

const projectCompletedFeedbackHeaderBar = projectId => ({
  color: "green",
  title: "Your Project Is Completed",
  text:
    "We hope you had a good experience working on your project. Don’t forget to leave feedback.",
  buttons: [
    {
      color: "green",
      text: "Submit Feedback",
      type: "link",
      to: `/member/review/${projectId}`
    }
  ]
});

const projectCompletedNoFeedbackHeaderBar = () => ({
  color: "green",
  title: "Your Project Is Completed",
  text: "Thank you for your feedback!"
});

class CandidateProjectContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentPageIndex: null,
      currentMemberProjectState: null,
      project: null,
      member: null,
      match: null,
      pitch: null,
      sow: null,
      requestedFeedbackCheck: false,
      messagesLoaded: false
    };

    this.completeProject = this.completeProject.bind(this);
    this.pitchMatch = this.pitchMatch.bind(this);
    this.rejectMatch = this.rejectMatch.bind(this);
    this.submitSOW = this.submitSOW.bind(this);
  }

  componentDidMount() {
    this.props.projectActions.getProject(this.props.match.params.projectId);
    this.props.dropdownsActions.getProjectBudgetRateTypes();
    this.props.dropdownsActions.getWorkTypes();
    this.props.dropdownsActions.getTaxStatus();
  }

  componentDidUpdate(prevProps, prevState) {
    this.setSubHeader(prevState);
    this.setHeaderBar(prevState);
    this.setHeaderCurrentMatch();
  }

  componentWillUnmount() {
    this.props.projectActions.onGetProjectSuccess(null);
    this.props.commonActions.setSubHeader({});
    this.props.commonActions.setHeaderBar({});
  }

  setSubHeader(prevState) {
    const { pathname } = this.props.location;

    let currentPageIndex = 2;

    if (pathname.includes("detail")) {
      currentPageIndex = 0;
    } else if (pathname.includes("sow")) {
      currentPageIndex = 1;
    } else if (pathname.includes("messages")) {
      currentPageIndex = 2;
    }

    if (currentPageIndex !== prevState.currentPageIndex) {
      this.props.commonActions.setSubHeader(
        subHeader(this.props.match.params.projectId, currentPageIndex)
      );
      this.setState({ currentPageIndex });
    }
  }

  setHeaderBar(prevState) {
    if (!_.isEmpty(this.props.project)) {
      const project = _.get(this.props.project, "data.data");
      const match = _.get(project, "matches[0]");
      const member = _.get(match, "member");
      const pitch = _.get(match, "pitch");
      const sow = _.get(pitch, "sow");

      const matchPitched = _.get(match, "pitched");
      const pitchAccepted = _.get(pitch, "accepted");
      const sowEditsRequested = _.get(sow, "edits_requested");
      const sowApproved = _.get(sow, "accepted");
      const projectCompleted =
        _.get(project, "status.name") === "completed" ||
        _.get(project, "status.name") === "reviewed";

      let headerBar = {};
      let currentMemberProjectState = null;

      if (projectCompleted) {
        //check if the member has already sent the feedback
        const canSendFeedback = this.props.project.canSendFeedback;
        const projectId = _.get(project, "id");

        if (canSendFeedback === null && !this.state.requestedFeedbackCheck) {
          const employerId = _.get(project, "user_id");
          this.setState({ requestedFeedbackCheck: true });
          this.props.projectActions.checkReviewer(projectId, employerId, true);
        } else if (canSendFeedback) {
          currentMemberProjectState = "projectCompletedFeedback";
          headerBar = projectCompletedFeedbackHeaderBar(projectId);
        } else if (canSendFeedback === false) {
          currentMemberProjectState = "projectCompletedNoFeedback";
          headerBar = projectCompletedNoFeedbackHeaderBar();
        }
      } else if (sowApproved) {
        // SOW Approved
        currentMemberProjectState = "sowApproved";
        headerBar = sowApprovedHeaderBar(this.completeProject, project.id);
      } else if (sowEditsRequested) {
        //Edits Requested
        currentMemberProjectState = "sowEditsRequested";
        headerBar = editsRequestedHeaderBar();
      } else if (sowApproved === null) {
        //Awaiting Sow Approval
        currentMemberProjectState = "awaitingSowApproval";
        headerBar = awaitingSowApprovalHeaderBar(sow.created_at);
      } else if (pitchAccepted) {
        //Pitch Accepted
        currentMemberProjectState = "pitchAccepted";
        headerBar = pitchAcceptedHeaderBar();
      } else if (matchPitched) {
        // Awating Employer response for the pitch
        currentMemberProjectState = "matchPitched";
        headerBar = awaitingPitchApprovalHeaderBar(
          pitch.created_at,
          project.id,
          !location.href.includes("messages")
        );
      } else if (match) {
        // Member can pitch the match from here
        currentMemberProjectState = "matched";
        headerBar = pitchItHeaderBar(match, this.pitchMatch, this.rejectMatch);
      }

      if (
        currentMemberProjectState !== prevState.currentMemberProjectState ||
        sow !== prevState.sow ||
        project !== prevState.project ||
        (headerBar &&
          this.state.currentPageIndex !== prevState.currentPageIndex)
      ) {
        const newState = {
          currentMemberProjectState,
          project,
          member,
          match,
          pitch,
          sow
        };
        this.props.commonActions.setHeaderBar(headerBar);

        if (
          pitch &&
          !this.state.messagesLoaded &&
          this.props.location.pathname.includes("messages")
        ) {
          newState.messagesLoaded = true;
          this.props.projectActions.getMessagesByPitchId(pitch.id);
        }

        this.setState(newState);
      }
    }
  }

  setHeaderCurrentMatch() {
    const { project } = this.state;

    if (project && project.user) {
      localStorage.setItem(
        "currentMatch",
        `${project.title} at ${project.user.first_name}`
      );
    }
  }

  completeProject(projectId) {
    this.props.projectActions.completeProjectByMember(projectId);
  }

  pitchMatch(match) {
    this.props.history.push(`/member/projects/matches/pitch-it/${match.id}`);
    Mixpanel.track("Member - Project Detail - Pitch It");
  }

  rejectMatch(match) {
    const payload = {
      match_id: match.id,
      declined: true
    };

    this.props.projectActions.declineMatch(payload);
    this.props.history.push("/member/projects/matches");
    Mixpanel.track("Member - Project Detail - No Thanks");
  }

  submitSOW(data) {
    const sow = this.state.sow;

    data.city = _.get(data, "city[0].description");

    if (!data.project_flexible) {
      data.project_flexible = false;
    }

    if (sow) {
      let pathName = _.replace(
        this.props.history.location.pathname,
        "/edit",
        ""
      );

      this.props.projectActions.updateSOW(
        sow.id,
        data,
        this.state.project.id,
        this.state.pitch.id,
        pathName
      );

      this.toast.showToast();
    } else {
      data.pitch_id = this.state.pitch.id;

      this.props.projectActions.storeSOW(data);
    }
  }

  getSowComponent() {
    const {
      projectBudgetRateTypes,
      workTypes,
      taxStatus,
      cities,
      citiesActions
    } = this.props;

    const { pathname } = this.props.location;
    const { project, sow, member } = this.state;

    const employer = _.get(project, "user");
    const status = _.get(project, "status.name");
    const disabled =
      status === "matched" || status === "pitched" || status === "completed";

    let component = (
      <ProjectSOWEdit
        sow={sow}
        projectBudgetRateTypes={
          projectBudgetRateTypes
            ? projectBudgetRateTypes.filter(type => type.id != 78)
            : projectBudgetRateTypes
        }
        workTypes={workTypes}
        taxStatus={taxStatus}
        onSubmit={this.submitSOW}
        disabled={disabled}
        cities={cities}
        onSearchCities={citiesActions.searchCitiesAutocomplete}
      />
    );

    if (
      (status === "in-progress" || status === "completed") &&
      !pathname.includes("/edit")
    ) {
      component = (
        <ProjectSOWView
          sowData={sow}
          member={member}
          employer={employer}
          projectData={project}
          fromMemberPage
        />
      );
    }

    return (
      <React.Fragment>
        <Toast
          onRef={ref => (this.toast = ref)}
          title="Your SOW has been updated"
          content="The employer has received an email alerting them to the changes."
        />
        {component}
      </React.Fragment>
    );
  }

  render() {
    let { currentMemberProjectState, project, match, pitch } = this.state;

    const messagesDisabled = currentMemberProjectState === "matched";
    const sowComponent = this.getSowComponent();
    project = project || {};
    match = match || {};
    pitch = pitch || {};

    const components = [
      <ProjectDetail projectData={project} />,
      sowComponent,
      pitch.accepted !== false && (
        <Messages
          messages={this.props.project.messages}
          disabled={messagesDisabled}
          matchDate={match.created_at}
          pitchId={pitch.id}
        />
      )
    ];

    return components[this.state.currentPageIndex] || null;
  }
}

const mapStateToProps = state => {
  return {
    project: state.project,
    projectBudgetRateTypes: state.dropdowns.projectBudgetRateTypes.data,
    workTypes: state.dropdowns.workTypes.data,
    taxStatus: state.dropdowns.taxStatus.data,
    cities: state.cities.cities.predictions
  };
};

const mapDispatchToProps = dispatch => {
  return {
    projectActions: bindActionCreators(projectActions, dispatch),
    commonActions: bindActionCreators(commonActions, dispatch),
    dropdownsActions: bindActionCreators(dropdownsActions, dispatch),
    citiesActions: bindActionCreators(citiesActions, dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CandidateProjectContainer);



// WEBPACK FOOTER //
// ./src/routes/candidate/project/CandidateProjectContainer.js